import React, { useState } from "react";
import HeaderComponent from "../header/HeaderComponent";
import FooterComponent from "../footer/FooterComponent";
import { v4 as uuidv4 } from "uuid";
import { Navbar } from "flowbite-react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { RegisterExternalServices } from "../../services/registerexternalservices/RegisterExternalServices";
import { BsWindowDash } from "react-icons/bs";

const RegisterExternal = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: "",
        last_name: "",
        email: "",
        source: "POEP",
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Generar ID único
        const userId = uuidv4().replace(/-/g, "").substring(0, 20);

        // Crear objeto con datos
        const userData = { ...formData, ciam_id: userId };

        console.log("Datos a enviar:", userData);

        try {
            const responseRegister = await RegisterExternalServices( userData );

            if (!responseRegister || responseRegister instanceof Error) {
                throw new Error("Respuesta inválida del servidor");
            }

            console.log("✅ Respuesta válida:", responseRegister);

            sessionStorage.setItem('token', responseRegister['token']);
            sessionStorage.setItem('idUser', responseRegister['id']);            
            sessionStorage.setItem('name', responseRegister['name']);
            sessionStorage.setItem('lastName', responseRegister['last_name']);
            sessionStorage.setItem('ciam_id', responseRegister['ciam_id']);
            sessionStorage.setItem('email', responseRegister['email']);
            sessionStorage.setItem('source', responseRegister['source']);

            Swal.fire({
                icon: 'success',
                title: 'Registro exitoso.',
                customClass: {
                    title: "text-center"
                },
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true,
            });

            navigate('/e-learning-hub');
            window.location.reload();

        } catch (error) {
            console.error("🔴 Error en handleLogin:", error);
            
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'error',
                title: 'El email se encuentra registrado',
                customClass: {
                    title: "text-center"
                },
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true,
            });
        }

    };
    return (
        <>
            <Navbar fluid rounded>
                <Navbar.Brand>
                    <img
                        src="/images/icons/nav-logo.png"
                        width="140"
                        height="80"
                        className="d-inline-block align-text-top p-2 ml-2"
                        alt="Logo"
                    />
                </Navbar.Brand>
                <Navbar.Collapse className="ml-auto mr-5">
                    <ul className='flex flex-col align-center items-center md:mt-0 md:flex-row md:space-x-8 md:text-sm md:font-medium'>
                    </ul>
                </Navbar.Collapse>
            </Navbar>

            <section className="bg-gray-50 dark:bg-gray-900 pt-40 pb-40">
                <div className="flex flex-col items-center px-6 mx-auto md:h-full lg:py-0">
                    <div className="w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 dark:bg-gray-800 dark:border-gray-700">
                        <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white">
                                Registrate aquí
                            </h1>
                            <form onSubmit={handleSubmit} className="space-y-4">
                                <div>
                                    <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                        Nombre
                                    </label>
                                    <input
                                        type="text"
                                        name="name"
                                        id="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                                        required
                                    />
                                </div>
                                <div>
                                    <label htmlFor="last_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                        Apellido
                                    </label>
                                    <input
                                        type="text"
                                        name="last_name"
                                        id="last_name"
                                        value={formData.last_name}
                                        onChange={handleChange}
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                                        required
                                    />
                                </div>
                                <div>
                                    <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                        Correo
                                    </label>
                                    <input
                                        type="email"
                                        name="email"
                                        id="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                                        required
                                    />
                                </div>
                                {/* <p className="text-sm font-light text-gray-500 dark:text-gray-400">
                                    ¿Ya tienes una cuenta? <a href="#" className="font-medium text-primary-600 hover:underline dark:text-primary-500">Inicia sesión aquí</a>
                                </p> */}
                                <button type="submit" className="w-full text-white bg-blue-700 hover:bg-blue-800 rounded-lg text-sm px-5 py-2.5 text-center">
                                    Registrarse
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>
            <FooterComponent />
        </>
    )
}

export default RegisterExternal;
